import { GetServerSideProps } from 'next';

import { Media } from '@/features/Media';
import { api } from '@/features/Media/api';
import { MediaDataType } from '@/features/Media/media.types';

import { withNavigationData } from '@/utils/withNavigationData';

type PageProps = {
  config: MediaDataType;
};

const Page = ({ config }: PageProps) => (
  <Media mediaData={config} />
);

export const getServerSideProps: GetServerSideProps = withNavigationData(async context => {
  const {
    query,
    locale,
  } = context;

  const page = query.page ?? '1';
  const parsedPage = Array.isArray(page) ?
    parseInt(page[0], 10) :
    parseInt(page, 10);

  let config;

  try {
    const { data: pageData } = await api.getMediaPage(
      { locale }
    );
    const { data: linksData } = await api.getMediaLinks(
      {
        locale,
        'pagination[page]': parsedPage,
        'pagination[pageSize]': 8,
        sort: 'date',
      }
    );

    config = {
      linksData,
      pageData,
    };
  } catch (error) {
    return {
      redirect: {
        destination: `/${context.locale}/404`,
        permanent: true,
      },
    };
  }

  return {
    props: {
      config,
    },
  };
});
export default Page;
